/**
 * Monta a URL pública do Notion para uma página a partir do pageId.
 *
 * O Notion aceita a URL no formato `https://www.notion.so/{pageId}` onde
 * o pageId pode vir com ou sem hifens. Removemos os hifens para ficar no
 * formato canônico usado quando você copia o link do Notion.
 */
export function buildNotionPageUrl(notionPageId: string | null | undefined): string | null {
  if (!notionPageId) return null;
  const clean = notionPageId.replace(/-/g, '').trim();
  if (!clean) return null;
  return `https://www.notion.so/${clean}`;
}
